export const fonts = [
  'sans-serif',
  'BebasNeue',
  'Inter',
  'Lato',
  'NotoSansArabic',
  'NotoSansHebrew',
  'NotoSansJP',
  'NotoSansSC',
  'NotoSansTC',
  'Montserrat',
  'OpenSans',
  'Oswald',
  'PlayfairDisplay',
  'Poppins',
  'Roboto',
];
